import LiveKitWaitingRoomContainer from './LiveKitWaitingRoomContainer';
import TwilioWaitingRoomContainer from './TwilioWaitingRoomContainer';

import TelemedicineContext from '../../context/telemedicine';
import { LIVEKIT_PROVIDER } from '../../utils/telemedicine';

import { useContext } from 'react';

const WaitingRoomContainer = () => {
	const { telemedicine } = useContext(TelemedicineContext);

	if (telemedicine?.provider === LIVEKIT_PROVIDER) {
		return <LiveKitWaitingRoomContainer />;
	}

	return <TwilioWaitingRoomContainer />;
};

export default WaitingRoomContainer;
